import styled from 'styled-components';

export const StyledMain = styled.main`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  flex: 1;
`;

export default { StyledMain };
